import React from 'react'

const FlexLayout = ({col1,col2}) => {
  return (
    <div style={{display:"flex"}}>
        <div style={{flex: "0 0 50%"}}>
          {col1}
        </div>
        <div style={{flex: "1"}}>
          {col2}
        </div>
      </div>
  )
}

export default FlexLayout